'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _mobxReact = require('mobx-react');

var _browserDetectionModel = require('./browser-detection-model');

var _browserDetectionModel2 = _interopRequireDefault(_browserDetectionModel);

var _browserDetection = require('./browser-detection');

var _browserDetection2 = _interopRequireDefault(_browserDetection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var detectionState = new _browserDetectionModel2.default();

var TRCBrowserDetection = function (_Component) {
  (0, _inherits3.default)(TRCBrowserDetection, _Component);

  function TRCBrowserDetection() {
    (0, _classCallCheck3.default)(this, TRCBrowserDetection);
    return (0, _possibleConstructorReturn3.default)(this, (TRCBrowserDetection.__proto__ || (0, _getPrototypeOf2.default)(TRCBrowserDetection)).apply(this, arguments));
  }

  (0, _createClass3.default)(TRCBrowserDetection, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_browserDetection2.default, { detectionState: detectionState });
    }
  }]);
  return TRCBrowserDetection;
}(_react.Component);

;

var _default = TRCBrowserDetection;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(detectionState, 'detectionState', 'src/core_modules/trc-browser-detection/index.jsx');

  __REACT_HOT_LOADER__.register(TRCBrowserDetection, 'TRCBrowserDetection', 'src/core_modules/trc-browser-detection/index.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', 'src/core_modules/trc-browser-detection/index.jsx');
}();

;


//////////////////
// WEBPACK FOOTER
// ./~/platform-client-bootstrap/dist/core_modules/trc-browser-detection/index.js
// module id = ./node_modules/platform-client-bootstrap/dist/core_modules/trc-browser-detection/index.js
// module chunks = 2